import React from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'
import styles from './styles'
import VectorIcon from '../../../../Assets/Images/icons/vector'
import UndoArrow from '../../../../Assets/Images/icons/undoArrow'
import FullscreenIcon from '@material-ui/icons/Fullscreen'
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit'
import SelectAllIcon from '@material-ui/icons/SelectAll'

const DrawMapControls = ({
  isDrawing,
  toggleDrawing,
  undoHandler,
  deleteSelected,
  removeAll,
  mapControls = [],
  shouldShowUndo,
  saving,
  classes,
  clearAllLabel,
  isFullScreen = false,
  onFullScreen = () => {},
  isSelecting = false,
  toggleAreaSelection = () => {},
}) => {
  if (mapControls.length === 0 || saving) return null

  return (
    <section className={classes.wrapper}>
      <span className={classes.title}>Actions</span>
      {mapControls.includes('DRAW') && (
        <div
          className={classnames(classes.button, {
            [classes.active]: isDrawing,
          })}
          onClick={() => {
            toggleDrawing()
          }}
        >
          <VectorIcon className={classes.buttonIcon} />
        </div>
      )}
      {mapControls.includes('SELECT_AREA') && (
        <div
          className={classnames(classes.button, {
            [classes.active]: isSelecting,
          })}
          onClick={toggleAreaSelection}
          title="Select area to group polygons"
        >
          <SelectAllIcon style={{ width: 18, height: 18 }} />
        </div>
      )}
      {shouldShowUndo && (
        <div
          className={classnames(classes.button, {
            [classes.inactive]: saving,
          })}
          onClick={undoHandler}
        >
          <UndoArrow className={classes.buttonIcon} />
        </div>
      )}
      {mapControls.includes('CLEAR_ALL') && (
        <div className={classes.button} onClick={removeAll}>
          {clearAllLabel ? clearAllLabel : 'Clear All'}
        </div>
      )}
      <span
        className={classes.fullScreenToggle}
        onClick={() => onFullScreen(isFullScreen => !isFullScreen)}
      >
        {isFullScreen ? (
          <FullscreenExitIcon fontSize="large" />
        ) : (
          <FullscreenIcon fontSize="small" />
        )}
      </span>
    </section>
  )
}

export default injectStyles(styles)(DrawMapControls)
